export default {
  'archiveStoreManagement.title': '店铺归档',
};
